<script lang="ts" generics="TValues">
    import Row from '$components/Form/Row.svelte';
    import type { Form } from '@jmvdevelop/svelte-form';
    import type { Fields } from '$components/MultiQuoteForm/MultiQuoteFormData';
    import PrettyChoiceMultiple from '$components/Form/PrettyChoiceMultiple.svelte';
    import PrettyChoice from '$components/Form/PrettyChoice.svelte';
    import Textarea from '$components/Form/Textarea.svelte';

    export let form: Form<TValues, string>;
    export let fields: Fields<TValues>;

    const serviceTypesOptions = [
        `Développement d'applications`,
        `Création de site internet`,
        `Réseaux informatiques`,
        `Cybersécurité`,
        `Intelligence artificielle pour entreprise`,
        `CRM professionnel`,
    ].map((v) => ({ label: v, value: v, key: v }));

    const projectTypeOptions = [
        `Projet spécifique`,
        `Besoin de conseils`,
        `Les deux`,
    ].map((v) => ({ label: v, value: v, key: v }));

    const companySizeOptions = [
        `Petite entreprise`,
        `Moyenne entreprise`,
        `Grande entreprise`,
        `Administration publique`,
    ].map((v) => ({ label: v, value: v, key: v }));
</script>

<div class="flex flex-col gap-8 @container">
    <Row
        {form}
        field={fields.ingenierieInformatique.serviceTypes}
        class=""
        let:field
        let:id
        label={`Quels types de services informatiques recherchez-vous ?`}
    >
        <PrettyChoiceMultiple
            {form}
            {field}
            {id}
            defaultClass="grid grid-cols-1 @[200px]:grid-cols-2 gap-x-6 gap-y-1"
            choices={serviceTypesOptions}
        />
    </Row>

    <Row
        {form}
        field={fields.ingenierieInformatique.projectType}
        class=""
        let:field
        let:id
        label={`Avez-vous un projet spécifique en tête ou avez-vous besoin de conseils pour définir vos besoins ?`}
    >
        <PrettyChoice
            {form}
            {field}
            {id}
            defaultClass="grid grid-cols-1 @[200px]:grid-cols-3 gap-x-6 gap-y-1"
            choices={projectTypeOptions}
        />
    </Row>

    <Row
        {form}
        field={fields.ingenierieInformatique.companySize}
        class=""
        let:field
        let:id
        label={`Quelle est la taille de votre entreprise ou organisation ?`}
    >
        <PrettyChoice
            {form}
            {field}
            {id}
            defaultClass="grid grid-cols-1 @[200px]:grid-cols-2 gap-x-6 gap-y-1"
            choices={companySizeOptions}
        />
    </Row>

    <Row
        {form}
        field={fields.message}
        required
        label={'Votre demande'}
        helpLabel="Précisez votre besoin : localisation, délais…"
        let:field
    >
        <Textarea
            {form}
            {field}
            placeholder={`Précisez votre besoin : localisation, délais…`}
            toText={(id) => id}
            fromText={(id) => id}
            class={''}
            rows={5}
        />
    </Row>
</div>
